















import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF } from '@/interfaces';

@Component
export default class DeviceStatusUpdatesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');

  public async handled(item) {
    item.state = 1;
    const response = await this.api.updateRecord(
      this.$store,
      this.apiUrl + item.id,
      item
    );
  }
}
